<div class="text-container">
  <span class="smartphoneHeading" [class.showText]="i == currentText" *ngFor="let t of text; let i = index;">
    {{ t }}
  </span>
</div>
